// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__wslPv","card":"NotFound_card__qeT5v","float":"NotFound_float__o06U8","title":"NotFound_title__wNCpW"};